module.exports = __webpack_public_path__ + "img/logo.cd0d46c7.png";